import { arrayOf, number, func, string } from 'prop-types';
import React from 'react';

const Tabs = ({ tabs, activeTab, onTabClick, additionalClasses = '' }) => {
	return (
		<div className={`navigation-tab bg-white border-0 ${additionalClasses}`}>
			<ul>
				{tabs.map((tab, index) => (
					<li
						key={index}
						className={activeTab === index ? 'active' : ''}
						onClick={() => !tab.disabled && onTabClick(index)}
					>
						{tab.name} {(tab.count && tab.count) > 0 && `(${tab.count})`}
					</li>
				))}
			</ul>
		</div>
	);
};

Tabs.propTypes = {
	tabs: arrayOf,
	activeTab: number,
	onTabClick: func,
	additioanlClassName: string
};

export default Tabs;
